import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Box,
} from "@mui/material";
import PropTypes from "prop-types";
import React, { useState } from "react";

const getHubStatus = () => [
  { label: "Orange Alert", value: "orange_alert" },
  { label: "Red Alert", value: "red_alert" },
  { label: "Normal", value: "normal" },
];

const emptySearchInputs = {
  hubId: "",
  status: "",
};

function HubSearchForm(props) {
  const {
    onSubmit,
    isSearchDisabled,
    defaultSearchInputs,
    statusPendingValidation,
    isCKD,
  } = props;

  const baseSearchInputs = { ...emptySearchInputs, ...defaultSearchInputs };
  const [searchInputs, setSearchInputs] = useState({ ...baseSearchInputs });

  const onChangeSearchInputs = (e) => {
    const { name, value } = e.target;
    setSearchInputs({
      ...searchInputs,
      [name]: value,
    });
  };

  const onFormSubmit = async (e) => {
    e.preventDefault();
    onSubmit({ ...searchInputs });
  };

  const onClearFilter = async (e) => {
    e.preventDefault();
    setSearchInputs({ ...baseSearchInputs });
    onSubmit({ ...baseSearchInputs });
  };

  return (
    <form style={{ marginBottom: 20 }} onSubmit={onFormSubmit}>
      <Box sx={{ display: "flex", gap: "15px", alignItems: "center" }}>
        <TextField
          label="Hub ID"
          name="hubId"
          onChange={onChangeSearchInputs}
          value={searchInputs.hubId}
          size="small"
          variant="standard"
        />
        {!isCKD && (
          <FormControl
            sx={{
              minWidth: "150px",
            }}
            size="small"
            variant="standard"
          >
            <InputLabel>Hub Status</InputLabel>
            <Select
              labelId="select-label"
              value={searchInputs.status}
              label="Delivery Status"
              name="status"
              disabled={statusPendingValidation}
              sx={{ textTransform: "capitalize" }}
              onChange={onChangeSearchInputs}
            >
              {getHubStatus().map((item) => (
                <MenuItem
                  value={item.value}
                  sx={{ textTransform: "capitalize" }}
                  key={item.value}
                >
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        <Button
          sx={{ marginRight: "15px" }}
          color="primary"
          type="submit"
          variant="contained"
          disabled={isSearchDisabled}
        >
          Search
        </Button>
        <Button
          color="error"
          variant="contained"
          disabled={!searchInputs.hubId && !searchInputs.status}
          onClick={onClearFilter}
        >
          Clear
        </Button>
      </Box>
    </form>
  );
}

HubSearchForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isSearchDisabled: PropTypes.bool,
  defaultSearchInputs: PropTypes.shape({
    takenAfterDate: PropTypes.instanceOf(Date),
  }),
  statusPendingValidation: PropTypes.string,
  isCKD: PropTypes.bool,
};

HubSearchForm.defaultProps = {
  isSearchDisabled: false,
  defaultSearchInputs: {},
  statusPendingValidation: null,
  isCKD: false,
};

export default HubSearchForm;
